/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { createEye } from '../../factoriesAny.js';
export var eyeDependencies = {
  createEye: createEye
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/es/entry/dependenciesAny/dependenciesEye.generated.js
// module id = 1542
// module chunks = 0